/**
 * Created by brycemeyer on 9/20/16.
 */

/*
 * The possible urls that this site will be on.
 * If you will be working on the site on a URL outside of the ones desfined below make sure to add it to this array.
 * This array is passed into the ColorBox class do determine if a clicked link within a window needs to
 * simply close the window.
 */
var siteUrls = ["maproyalty.local", "maproyalty.com", "qa.maproyalty.com", "map.pomeloproductions.com"];

jQuery(document).ready(function() {

    new ColorBox(siteUrls);
});

Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

Array.prototype.compare = function(testArr) {
    if (this.length != testArr.length) return false;
    for (var i = 0; i < testArr.length; i++) {
        if (this[i].compare) { //To test values in nested arrays
            if (!this[i].compare(testArr[i])) return false;
        }
        else if (this[i] !== testArr[i]) return false;
    }
    return true;
};

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }
    
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}